import { IEnvironmentInfo, IComponentInfo, IPackageInfo, IApplicationInfo, ComponentType } from './app-context.service';
import { Equipment_ModuleContextService } from './Equipment.context.service';

import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class Equipment_create_equipment_type_form_ComponentContextService {
  private readonly moduleContext: Equipment_ModuleContextService;

  constructor(moduleContext: Equipment_ModuleContextService) {
    this.moduleContext = moduleContext;
  }

  public get app(): IApplicationInfo {
    return this.moduleContext.app;
  }

  public get env(): IEnvironmentInfo {
    return this.moduleContext.env;
  }

  public get package(): IPackageInfo {
    return this.moduleContext.package;
  }

  public get component(): IComponentInfo {
    return {
      name: 'create_equipment_type_form',
      type: ComponentType.form
    }
  }
}